import React from 'react';
import styles from 'components/get-pi-cities/index.module.scss';
import pi from 'assets/icon_pi.svg';

const GetPiCities = ({ cities = '' }) => {
  if (cities === '') return <></>;

  const piCities = () => {
    return cities
      .filter(city => {
        return city.source === 'pi';
      })
      .map(city => {
        return city.name;
      })
      .join('/');
  };

  if (piCities.length === 0) return <></>;

  return (
    <div className={styles.pi}>
      {piCities()}付款由
      <img src={pi} alt="pi" />
      拍錢包提供
    </div>
  );
};

export default GetPiCities;
